<div class="p-2">
  <div>{{"comment"|language}}</div>
  <textarea class="w-100 mt-2" rows="5" [(ngModel)]="this.builder.stickerDetails.message"></textarea>
  <div>
    <button mat-flat-button class="submit-button" (click)="addComment()">{{"submit"|language}}</button>
  </div>
</div>